/*
  Contact form tracking — attribution + engagement.

  1. Fills the hidden `contact[Source]` field from the first-touch source captured
     in theme.liquid, so the notification email says where the enquiry came from.
  2. Fires GA4 events: contact_form_start, contact_form_abandon, generate_lead.

  Event names are namespaced deliberately. GA4 Enhanced Measurement already emits its own
  `form_start` and `form_submit` on this property, and those fire for ANY form on the page
  (newsletter, search). Reusing those names would double-count and would pair an abandon
  count against a denominator that includes unrelated forms.

  GA4 on this store is installed as a sandboxed Shopify web pixel, so gtag() is not
  reachable from theme scope. We load our own gtag with send_page_view:false (no
  duplicate pageviews) and only on first interaction — visitors who never touch the
  form download nothing extra.

  contact_form_abandon carries METADATA ONLY — which fields were filled, message length,
  time on form. It never sends what anyone typed.
*/
(function () {
  if (window.lzContactTrackingInit) return;
  window.lzContactTrackingInit = true;

  var form = document.getElementById('ContactForm');
  if (!form) return;

  var GA_ID = 'G-NL5P1911ZX';
  var FIELDS = ['name', 'email', 'phone', 'budget', 'body'];

  function field(name) {
    return document.getElementById('ContactForm-' + name);
  }

  // ——— hidden source field ———
  var sourceInput = field('source');
  if (sourceInput) {
    var src = 'direct';
    var landing = '';
    try {
      src = sessionStorage.getItem('lz_src') || 'direct';
      landing = sessionStorage.getItem('lz_landing') || '';
    } catch (e) {}
    sourceInput.value =
      src + (landing && landing !== location.pathname ? ' (landed on ' + landing + ')' : '');
  }

  // ——— lazy GA4 loader ———
  var gaLoaded = false;
  function gtag() {
    (window.dataLayer = window.dataLayer || []).push(arguments);
  }
  function loadGA() {
    if (gaLoaded) return;
    gaLoaded = true;
    // The store already runs a main-frame gtag for this stream on most pages —
    // reuse it rather than configuring the same measurement ID twice.
    if (window.google_tag_manager && window.google_tag_manager[GA_ID]) return;
    var s = document.createElement('script');
    s.async = true;
    s.src = 'https://www.googletagmanager.com/gtag/js?id=' + GA_ID;
    document.head.appendChild(s);
    gtag('js', new Date());
    gtag('config', GA_ID, { send_page_view: false });
  }

  function track(name, params) {
    loadGA();
    params = params || {};
    params.page_location = location.href;
    params.page_path = location.pathname;
    params.page_title = document.title;
    gtag('event', name, params);
  }

  /* Meta Lead, alongside the GA4 event.

     Two things have to be true before this can fire, and neither is true when
     this script first runs: the Facebook pixel is delivered by Shopify's async
     web-pixels-manager, so window.fbq is still undefined at parse time, and the
     customer-privacy API resolves separately. So wait for both rather than
     testing once and giving up -- the earlier version tested `typeof fbq ===
     "function"` immediately and silently dropped every Lead.

     Fails closed on consent: if the privacy API has not resolved yet we keep
     waiting rather than sending, and if it resolves to "marketing not allowed"
     we never send at all. A theme-level fbq call bypasses the privacy layer
     Shopify's own web pixels sit behind, so this has to gate itself.

     Why it exists: Meta had no lead signal. Its only conversion event was
     Purchase, which this store almost never fires -- custom work is invoiced off
     Shopify, consultations book through Bloom without a checkout, and the gallery
     products have no add-to-cart. */
  function metaLead(params) {
    var tries = 0;
    (function attempt() {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      var consentKnown = cp && typeof cp.marketingAllowed === 'function';
      if (consentKnown && !cp.marketingAllowed()) return;
      if (consentKnown && typeof window.fbq === 'function') {
        try { window.fbq('track', 'Lead', params); } catch (e) {}
        return;
      }
      if (++tries > 40) return;
      setTimeout(attempt, 250);
    })();
  }

  function sess(op, key, val) {
    try {
      if (op === 'get') return sessionStorage.getItem(key);
      if (op === 'set') sessionStorage.setItem(key, val);
      if (op === 'del') sessionStorage.removeItem(key);
    } catch (e) {}
    return null;
  }

  // ——— completed submission (Shopify re-renders the page on success) ———
  // Shopify sets posted_successfully? from ?contact_posted=true, so ANY landing on
  // that URL — a refresh, a back-navigation, a bookmark, a fresh session hours later —
  // re-renders as "posted". The old guard fired on the first such render per session,
  // which over-counted badly: one struggling visitor who reached the thank-you page
  // across three sessions logged three generate_lead events (verified 14 Sep). Some
  // were revisits, not submissions.
  //
  // Tie the lead to an ACTUAL submit instead of to the URL. The submit handler below
  // stamps a timestamp when a real form submission fires; that stamp survives the
  // POST -> redirect (same session, same tab), so the thank-you render fires the lead
  // exactly once and consumes the stamp. A revisit or refresh has no fresh stamp, so
  // it never fires. A genuinely new submission stamps again and counts again.
  var LEAD_PENDING = 'lz_lead_pending';
  var PENDING_WINDOW_MS = 10 * 60 * 1000; // the redirect lands in seconds; 10 min is generous margin

  if (window.lzContactPosted) {
    var pend = sess('get', LEAD_PENDING);
    sess('del', LEAD_PENDING); // consume it either way, so a refresh can never refire
    if (pend && (Date.now() - Number(pend)) < PENDING_WINDOW_MS) {
      track('generate_lead', { form_id: 'contact' });
      metaLead({ content_name: 'contact form' });
    }
  }

  // ——— start / abandon ———
  var started = false;
  var submitted = false;
  var reported = false;
  var startedAt = 0;

  function onFirstInput() {
    if (started) return;
    started = true;
    startedAt = Date.now();
    track('contact_form_start', { form_id: 'contact' });
  }

  FIELDS.forEach(function (name) {
    var el = field(name);
    if (el) el.addEventListener('input', onFirstInput, { passive: true });
  });

  var fileInput = field('file');
  if (fileInput) fileInput.addEventListener('change', onFirstInput);

  // Capture phase: runs before the section's own handler calls preventDefault().
  // Stamp the moment of a real submit so the thank-you render — after Shopify's
  // POST -> redirect, same session — knows a genuine submission just happened and
  // fires generate_lead exactly once. setItem is synchronous, so it lands before
  // the browser starts navigating.
  form.addEventListener(
    'submit',
    function () {
      submitted = true;
      sess('set', LEAD_PENDING, String(Date.now()));
    },
    true
  );

  function reportAbandon() {
    if (!started || submitted || reported) return;

    var filled = [];
    var messageLength = 0;
    FIELDS.forEach(function (name) {
      var el = field(name);
      if (el && el.value.trim()) {
        filled.push(name);
        if (name === 'body') messageLength = el.value.trim().length;
      }
    });
    if (!filled.length) return;

    var seconds = Math.round((Date.now() - startedAt) / 1000);
    if (seconds < 2) return; // stray keypress or bot

    reported = true;
    track('contact_form_abandon', {
      form_id: 'contact',
      fields_filled: filled.join(','),
      fields_filled_count: filled.length,
      furthest_field: filled[filled.length - 1],
      message_length: messageLength,
      wrote_message: messageLength > 0 ? 'yes' : 'no',
      seconds_on_form: seconds
    });
  }

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') reportAbandon();
  });
  window.addEventListener('pagehide', reportAbandon);
})();
